import Countdown from "react-countdown";
import { useTranslation } from 'react-i18next';
import { EeljProps } from "./EeljInfo";

const CountdownRenderer = ({days, hours, minutes, seconds, dark}: any) => {
  const { t } = useTranslation();
  const timeUnits = [
    { value: days, label: t('countdown.days') },
    { value: hours, label: t('countdown.hours') },
    { value: minutes, label: t('countdown.minutes') },
    { value: seconds, label: t('countdown.seconds') },
  ];

  return (
    <div className="flex items-center justify-center gap-3 sm:gap-4 w-full">
      {timeUnits.map((unit) => (
        <div key={unit.label} className="flex flex-col items-center">
          <div className={`w-16 h-16 sm:w-20 sm:h-20 rounded-2xl flex items-center justify-center ${
            dark
              ? 'bg-white/10 border border-white/10 backdrop-blur-sm'
              : 'bg-neutral-900'
          }`}>
            <span className="text-2xl sm:text-3xl font-bold text-white tabular-nums">
              {String(unit.value).padStart(2, '0')}
            </span>
          </div>
          <p className={`text-xs font-medium mt-2 uppercase tracking-wide ${
            dark ? 'text-slate-400' : 'text-neutral-500'
          }`}>
            {unit.label}
          </p>
        </div>
      ))}
    </div>
  );
}

export const EeljCountdown = (eelj: EeljProps & { dark?: boolean }) => {
  const { t } = useTranslation();
  const isExpired = new Date() > new Date(eelj.orderStartDate);
  const dark = eelj.dark;

  return (
    <div className="w-full flex flex-col items-center">
      <div className="w-full max-w-2xl">
        <div className="text-center mb-8">
          <h3 className={`text-2xl sm:text-3xl font-extrabold mb-2 ${
            dark ? 'text-white' : 'text-neutral-900'
          }`}>
            {eelj.title}
          </h3>
          <p className={`text-base mb-4 ${dark ? 'text-slate-400' : 'text-neutral-500'}`}>
            {t('countdown.orderTimeLeft')}
          </p>
          <div className={`inline-flex items-center gap-2 px-4 py-1.5 rounded-full ${
            dark
              ? 'border border-white/15 bg-white/5 backdrop-blur-sm'
              : 'border border-neutral-200 bg-white'
          }`}>
            <span className={`text-sm font-medium ${dark ? 'text-slate-300' : 'text-neutral-700'}`}>
              {eelj.ageGroup}
            </span>
          </div>
        </div>

        {isExpired ? (
          <div className="text-center py-6">
            <p className={`text-xl font-bold mb-4 ${dark ? 'text-white' : 'text-neutral-900'}`}>
              {t('countdown.orderStarted')}
            </p>
            <CountdownRenderer {...{days: 0, hours: 0, minutes: 0, seconds: 0, dark}}/>
          </div>
        ) : (
          <Countdown
            date={eelj.orderStartDate}
            renderer={(props) => {
              return <CountdownRenderer {...props} dark={dark}/>;
            }}
          >
            <CountdownRenderer {...{days: 0, hours: 0, minutes: 0, seconds: 0, dark}}/>
          </Countdown>
        )}
      </div>
    </div>
  )
}

export default EeljCountdown;
